import React, { useEffect, useRef, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import { defineDefinitionExpression } from '../../../utils/helpers/map/defExpHelper';
import {
  getInfoBulleMessage,
  getOptionsCommunes,
  getOptionsInstalls,
  resetImputLabel,
  resetOptions,
} from '../../../utils/helpers/module/filtersHelper';
// NOTE: resetOptions / resetImputLabel are kept for TypeSelector reset and initial empty-check
import { colorFormated } from '../../../utils/helpers/module/moduleComponentHelper';
import DataSelector from '../../common/component/dataSelector';
import Legend from '../../common/component/Legend';
import TypeSelector from '../../common/component/typeSelector';
import DoubleFilter from '../component/DoubleFilter';
import { typeOptionsPluie } from '../options/optionsHelper';
import { loaderDataComponent } from '../../../utils/helper';

const FiltersPluie = (props: any) => {
  const contractCode = window.sessionStorage.getItem('contractCode') || '';
  // const for dropdownlist on change
  const [fonctionnement, setFonctionnement] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('pluie_color')!) || ''
  );
  const [commune, setCommune] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('pluie_commune')!) || {
      name: '',
      code: '',
    }
  );
  const [type, setType] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('pluie_type')!) || {
      name: '',
      code: "MDI_DO','MDI_PR,TP",
    }
  );
  const [installations, setInstallations] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('pluie_installation')!) || {
      name: '',
      code: '',
    }
  );
  // const for dropdownlists options
  const [communeOptions, setCommuneOptions] = useState<any>([]);
  const [installsOptions, setInstallsOptions] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  // ref to always access the latest commune value in callbacks (prevents stale-closure bug
  // when filterTwoParam changes after parentCallbackOne triggers DOM event via resetOptions)
  const communeRef = useRef<any>(commune);
  communeRef.current = commune;

  const infoBulleMessageDataSelectorPluie = getInfoBulleMessage(props.module);

  // get communes options
  const getCommune = async () => {
    const optionsCommune = await getOptionsCommunes(
      contractCode,
      '55',
      props.module
    );
    if (optionsCommune.length === 0) {
      resetImputLabel('pluie-filtre-commune');
    }
    setCommuneOptions(optionsCommune);
  };

  // get installs options
  const getInstall = async (pFilters: any) => {
    const res = await getOptionsInstalls(
      defineDefinitionExpression(pFilters, 'modules', contractCode),
      '55'
    );
    if (res.length === 0) {
      resetImputLabel('pluie-filtre-installation');
    }
    setInstallsOptions(res);
  };

  // component did mount
  useEffect(() => {
    // load memory and launch table and map
    props.parentCallback({
      Color: fonctionnement,
      InseeCode: commune,
      Code: installations,
    });
    setLoading(true);
    getCommune().then(() => {
      setLoading(false);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // trigger dynamic dropdownlists hence on change (commune, type and deversement)
  useEffect(() => {
    if (loading === false) {
      setLoading(true);
      getInstall({
        Color: colorFormated(fonctionnement),
        InseeCode: commune,
      }).then(() => {
        setLoading(false);
      });
    }
  }, [commune, fonctionnement]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container className='filterForm'>
      <Card automatedTestId={props.module + '-filter'}>
        <Word
          value='FILTRER MA RECHERCHE'
          textStyle='title'
          variant='h1'
          automatedTestId='search-word'
        />
        <Legend type={localStorage.getItem('type')!} />
        <Container className='rowContainer'>
          <Container
            className='colContainer'
            style={{
              display: 'inline-block',
              width: '-webkit-fill-available',
            }}
          >
            <Word
              value='Catégorisation'
              textStyle='normalReg'
              variant='p'
              automatedTestId='id-catgeorisation'
            />
            <DataSelector 
              infoBulles={infoBulleMessageDataSelectorPluie}
              sendSelectedColor={(d: any) => {
                setFonctionnement(d);
                fonctionnement !== '' &&
                  props.parentCallback({
                    Color: d,
                    InseeCode: commune,
                    ModelCode: type,
                    Code: installations,
                  });
                window.sessionStorage.setItem('pluie_color', JSON.stringify(d));
              }}
              type='pluie'
              sessionStorageName='pluie_color'
            />
          </Container>
          <Container
            className='colContainer'
            style={{
              display: 'inline-block',
              paddingLeft: '5px',
              width: '-webkit-fill-available',
            }}
            id='Container-id-type'
          >
            <Word
              value='Type'
              textStyle='normalReg'
              variant='p'
              automatedTestId='id-type'
            />
            <TypeSelector
              sendSelectedColor={(event: any, option: any) => {
                setType(option);
                resetOptions(
                  option,
                  'pluie-filtre-installation',
                  setInstallsOptions
                );
                props.parentCallback({
                  Color: fonctionnement,
                  InseeCode: commune,
                  ModelCode: option,
                  Code: {
                    name: '',
                    code: '',
                  },
                });
                window.sessionStorage.setItem(
                  props.module + '_type',
                  JSON.stringify(option)
                );
              }}
              radioParams={typeOptionsPluie}
              module={props.module}
              option={''}
            />
          </Container>
        </Container>
        {commune !== null && (
          <DoubleFilter
            key={commune.code + '|' + commune.name}
            module='pluie'
            titleOne='Communes :'
            filterNameOne='commune'
            filterOneOptions={communeOptions}
            titleTwo='Installations :'
            filterNameTwo='installation'
            filterTwoOptions={installsOptions}
            parentCallbackOne={(d) => {
              setCommune(d);
              // Clear installation state + sessionStorage synchronously.
              // We do NOT call resetOptions/resetImputLabel here because those
              // dispatch a DOM change event that MUI Autocomplete re-emits as an
              // onChange → setFilterTwoParam → parentCallbackTwo with the stale
              // old commune (FiltersPluie hasn't re-rendered yet).  Instead the
              // key={commune.code} on <DoubleFilter> below causes it to unmount/
              // remount whenever commune changes, giving a clean slate with no
              // spurious callbacks and no stale closure issues.
              const emptyInstall = { name: '', code: '' };
              setInstallations(emptyInstall);
              window.sessionStorage.setItem('pluie_installation', JSON.stringify(emptyInstall));
              // Clear options directly – no DOM events fired.
              setInstallsOptions([]);
              props.parentCallback({
                Color: fonctionnement,
                InseeCode: d,
                ModelCode: type,
                Code: emptyInstall,
              });
            }}
            parentCallbackTwo={(d) => {
              setInstallations(d);
              // communeRef.current is always up-to-date (see declaration above).
              props.parentCallback({
                Color: fonctionnement,
                InseeCode: communeRef.current,
                ModelCode: type,
                Code: d,
              });
            }}
          />
        )}
        {loaderDataComponent(loading)}
      </Card>
    </Container>
  );
};
export default FiltersPluie;
